import { NavItemType } from '@/router/type'

const professionalsRouterItems: NavItemType[] = [
  {
    id: 'professionals',
    title: 'Profissionais',
    icon: 'group',
    type: 'collapse',
    pathname: '/usuario/profissionais',
    children: [
      {
        id: 'clinical-staff',
        title: 'Corpos clínicos',
        url: '/corpo-clinico',
        type: 'item',
      },
      {
        id: 'duty-shifts',
        title: 'Plantões',
        url: '/plantoes',
        type: 'item',
      },
      {
        id: 'absence-reschedule-log',
        title: 'Ausências Programadas',
        url: '/reagendamentos-ausencia',
        type: 'item',
      },
    ],
  },
]

export default professionalsRouterItems
